import {$} from '../jquery-definition.js';
import 'is-in-viewport';

$( function() {
	autoplayVideo();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		autoplayVideo();
	}, 100 );
} );

function autoplayVideo() {
	$( '.autoplay' ).each( function() {
		var $this = $( this );
		var video = $this.find( 'video' )[ 0 ];

		if ( video ) {
			if ( $this.is( ':in-viewport' ) ) {
				video.play();
			} else {
				video.pause();
			}
		}
	} );
}
